// pages/Login.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
    const [login, setLogin] = useState("");      // username or email
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const { login: doLogin, user } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        if (!login.trim() || !password) return;

        setError("");
        setSubmitting(true);
        try {
            await doLogin(login.trim(), password);
            navigate("/profile");
        } catch (err) {
            setError(err.message || "Login failed");
        } finally {
            setSubmitting(false);
        }
    }

    // ALREADY LOGGED IN
    useEffect(() => {
        if (user) navigate("/profile");
    }, [user, navigate]);

    return (
        <div className="wrapper">
            <h1>Login</h1>

            {error && <p className="error-msg" style={{ color: "red" }}>{error}</p>}

            <form onSubmit={handleSubmit} className="account-form">
                <div className="account-form__input-group">
                    <input
                        className="account-form__input"
                        type="text"
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                        placeholder="Username or email"
                        autoComplete="username"
                        required
                    />
                    <span className="account-form__icon material-symbols-outlined">person</span>
                </div>
                <div className="account-form__input-group">
                    <input
                        className="account-form__input"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        autoComplete="current-password"
                        required
                    />
                    <span className="account-form__icon material-symbols-outlined">key</span>
                </div>
                <button type="submit" disabled={submitting}>
                    {submitting ? "Logging in…" : "Login"}
                </button>
            </form>

            <p>Don't have an account? <Link to="/register">Register</Link></p>
        </div>
    );
}